export default __webpack_public_path__ + "static/media/account-white-dashboard-icon.0e06b478.svg";